<template>
  <v-row align="center">
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">{{ title }} Grade</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form lazy-validation autocomplete="off">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="grade.title"
                    :error="$v.grade.title.$error"
                    outlined
                    dense
                  >
                    <template v-slot:label>
                      Title <span class="text-danger">*</span>
                    </template>
                  </v-text-field>
                  <span class="text-danger" v-if="$v.grade.title.$error"
                    >This Field is required</span
                  >
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="grade.level_id"
                    :error="$v.grade.level_id.$error"
                    :items="levels"
                    item-text="title"
                    item-value="id"
                    outlined
                    dense
                  >
                    <template v-slot:label>
                      Level <span class="text-danger">*</span>
                    </template>
                  </v-select>
                  <span class="text-danger" v-if="$v.grade.level_id.$error"
                    >This Field is required</span
                  >
                </v-col>

                <v-col cols="12">
                  Status
                  <v-switch
                    v-model="grade.is_active"
                    :label="grade.is_active ? 'Yes' : 'No'"
                    outlined
                    dense
                  ></v-switch>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="createOrUpdate">
            {{ edit ? "Update" : "Save" }}
          </v-btn>
          <v-btn color="red darken-1" dark @click="closeDialog"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import GradeService from "@/service/grade/GradeService";
import LevelService from "@/service/level/LevelService";

const grade = new GradeService();
const level = new LevelService();

export default {
  name: "CreateAndUpdate",
  data() {
    return {
      dialog: false,
      edit: false,
      imgUrl: null,
      levels: [],
      grade: {
        title: "",
        level_id: "",
        is_active: true
      },
      errors: []
    };
  },
  validations: {
    grade: {
      title: { required },
      level_id: { required }
    }
  },
  mounted() {
    this.getAllLevels();
  },
  methods: {
    getAllLevels() {
      level
        .all()
        .then(response => {
          this.levels = response.data.data;
        })
        .catch(() => {});
    },
    openDialog() {
      this.dialog = true;
      this.edit = false;
      this.resetForm();
    },
    editDialog(grade) {
      this.dialog = true;
      this.edit = true;
      this.resetForm();
      this.grade = grade;
    },
    closeDialog() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.$v.$reset();
      this.grade = {
        title: "",
        level_id: "",
        is_active: true
      };
    },
    createOrUpdate() {
      this.$v.$touch();
      if (this.$v.$error) {
        setTimeout(() => {
          this.$v.$reset();
        }, 6000);
      } else {
        if (this.edit) {
          grade
            .update(this.grade.id, this.grade)
            .then(response => {
              if (response.data.status === "OK") {
                this.$snotify.success("Grade updated successfully");
                this.$emit("refresh");
                this.closeDialog();
              }
            })
            .catch(error => {
              this.errors = error.response.data.errors;
            });
        } else {
          grade
            .store(this.grade)
            .then(response => {
              if (response.data.status === "OK") {
                this.$snotify.success("Grade created successfully");
                this.$emit("refresh");
                this.closeDialog();
              }
            })
            .catch(error => {
              this.errors = error.response.data.errors;
            });
        }
      }
    }
  },
  computed: {
    title() {
      if (this.edit != null || this.edit != undefined) {
        return "Edit";
      } else {
        return "Create";
      }
    }
  }
};
</script>
